module.exports = __webpack_public_path__ + "img/77.4d965f9b.png";